import React, { useEffect, useRef } from "react";


/**
 * update: true/false, true일 때 스크롤 하단으로 이동
 * 
 * @param {스크롤 따라감 여부} update 
 * @returns 
 */
export const UseViewToBottom = (update) => {

    const elemRef = useRef(null);

    useEffect(() => {

        elemRef.current.scrollTo({
            top: elemRef.current.scrollHeight,
            behavior: 'smooth',
        })
    }, [update])
    return elemRef;
}

